import React from 'react';
import ModalVideo from 'react-modal-video';
import PreLoginPage from '../../views/core/PreLoginPage';
import HmEventRegistry from '../../model/HmEventRegistry';

// ES6 class-style
class HomeworkVideoComponent extends PreLoginPage {
  

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.swiper = null
  }

  componentDidMount(){
	HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	}

  goNext() {
    if (this.swiper) this.swiper.slideNext()
  }
 
  goPrev() {
    if (this.swiper) this.swiper.slidePrev()
  }

  openModal (someValue) {
    this.setState({isOpen: true})
    this.videoId = someValue
    console.log(this.videoId);
  }

  onClickDemoFn = () => {
	if(typeof this.props.demoFn === "function"){
		this.props.demoFn();
	}
}

  getDemoFn = () =>{
    return(
        <div className='col-md-12 mb-10 demobtn'>		
            <span data-ga="Homework-Demovideo" onClick={this.onClickDemoFn} className="r-btn contactbtn">{this.rb("homework.demo")}</span>		  					  		
              </div>
    )
}

  render() {
  	const videoId = '';
	const params = {
		slidesPerView: 1,
	 	spaceBetween: 30,
	 	loop: false,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    }
		}
	} 
	
	let url = window.homeworkVideoURL;

  	return(
         
  	<section className="mtb video-container homework-video">
		<div className="row">
			<div className="container">
                {/* <h3 className="title">{this.rb("homework.use")}</h3> */}
				{/* <Swiper className="student-slider" slidesPerView={params.slidesPerView}  breakpoints={params.breakpoints} loop={params.loop} spaceBetween={params.spaceBetween} ref={node => {if(node) this.swiper = node.swiper} }> */}
					
					<div data-ga="Homework-Demovideo" className="swiper-slide">
						<div className="img-box popup-youtube single-video" onClick={this.openModal.bind(null,url)}>
							<img src="/img/homework.png" alt="How HeyMath! really empowers Tutors and Teachers"/>
							<a><span className="play-btn"></span></a>
						</div>
                        {/* {this.getDemoFn()} */}
					</div>
				{/* </Swiper> */}
				{/* <div className="slider-btns">
	        		<div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
	        		<div className="swiper-button-next swp-next"  onClick={this.goNext}></div>
        		</div> */}
			</div> 
		</div>
		<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
	</section>
  	);
  }
}

export default HomeworkVideoComponent;


// WEBPACK FOOTER //
// ./src/vendors/homework/HomeworkVideoComponent.js